var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stageCards",class:['v-stage-cards', _vm.label],on:{"click":_vm.go_children_nav}},[_c('div',{staticClass:"cards-cover"},[_c('div',{staticClass:"cover-image"},[_c('v-img',{attrs:{"path":_vm.images}})],1),_c('h4',{staticClass:"page-stage-title",domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }